import { SVGProps, Ref, forwardRef } from "react";

const SearchIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Search Icon"
    {...props}
  >
    <title id="Search Icon">Search Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m20 20-5.333-5.333m1.777-4.445a6.222 6.222 0 1 1-12.444 0 6.222 6.222 0 0 1 12.444 0Z"
    />
  </svg>
);

const ForwardRef = forwardRef(SearchIcon);
export default ForwardRef;
